import { HTMLAttributes, KeyboardEvent, MouseEvent, ReactNode, useCallback } from 'react';
import Modal from 'react-modal';
import { Icon, IconName } from '../../Graphics';
import './style.scss';
import { useFullscreen } from '../../Fullscreen';

const CLOSE_TIMEOUT = 500;

export type SlidingPaneProps = HTMLAttributes<HTMLDivElement> & {
  isOpen: boolean;
  rootAppElement: string;
  className?: string;
  closeImmediately?: boolean;
  from?: 'left' | 'right' | 'bottom';
  onAfterClose?: () => void;
  onAfterOpen?: () => void;
  onRequestClose?: (event: MouseEvent | KeyboardEvent) => void;
  overlayClassName?: string;
  width?: string;
  children?: ReactNode;
};

export const SlidingPane = ({
  children,
  isOpen,
  rootAppElement,
  className = '',
  closeImmediately = true,
  from = 'right',
  onAfterClose,
  onAfterOpen,
  onRequestClose,
  overlayClassName = '',
  width = '80%',
}: SlidingPaneProps) => {
  const fullscreen = useFullscreen();
  const directionClass = `slide-pane_from_${from}`;
  Modal.setAppElement(rootAppElement);

  const parentSelector = useCallback(
    () => (fullscreen.container instanceof HTMLElement ? fullscreen.container : document.body),
    [fullscreen.container]
  );

  return (
    <Modal
      className={`slide-pane ${directionClass} ${className}`}
      style={{
        content: { width },
      }}
      overlayClassName={`slide-pane__overlay ${overlayClassName}`}
      closeTimeoutMS={closeImmediately ? 0 : CLOSE_TIMEOUT}
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      onAfterClose={onAfterClose}
      contentLabel="Slider"
      parentSelector={parentSelector}
    >
      <div
        role="button"
        onClick={onRequestClose}
        onKeyPress={onRequestClose}
        tabIndex={0}
        className="slide-pane__close"
      >
        <Icon name={IconName.Close} />
      </div>
      <div className="slide-pane__content">{children}</div>
    </Modal>
  );
};
